import { render, staticRenderFns } from "./AddLetterTemplate.vue?vue&type=template&id=5337f6b4&"
import script from "./AddLetterTemplate.vue?vue&type=script&lang=js&"
export * from "./AddLetterTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports